// Components
import { NumberInput } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function Amount(): JSX.Element {
  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="amount"
      control={control}
      render={({ field, fieldState }) => (
        <NumberInput
          inputClass="text-right"
          label="PAYMENT AMOUNT"
          decimalSeparator="."
          thousandSeparator=","
          error={fieldState.error?.message}
          ref={field.ref}
          value={field.value}
          onValueChange={e => field.onChange(e.floatValue ?? 0)}
        />
      )}
    />
  )
}